import { Injectable } from '@angular/core';
import { AdminDashboardService } from './admin-dashboard.service';
import { Observable } from 'rxjs';
import { DashboardEmployee, DashboardEmployeeCalendarStats } from 'app/model/dashboardEmployee';
import { UserService } from '../user-service';
import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { CalendarStatus } from 'app/model/calendar';
import { UserCalendarStats } from 'app/model/userCalendarStats';

@Injectable({
  providedIn: 'root'
})
export class DashboardAdminEmployeeService {
  private readonly ACCEPTED_PREFIX: string = 'accepted'
  private readonly PENDING_PREFIX: string = 'pending'

  private readonly HOLIDAYS_SUFFIX: string = `holidays`
  private readonly PERSONAL_MATTERS_SUFFIX: string = `personal_matters`
  private readonly SICK_LEAVE_SUFFIX: string = `sick_leave`
  private readonly PAID_LEAVE_SUFFIX: string = `paid_leave`
  private readonly REMOTE_WORK_SUFFIX: string = `remote_work`

  /**
   * Constructor
   *
   * @param {AdminDashboardService} adminDashboardService
   * @param {UserService} userService
   * 
  */
  constructor(
    private adminDashboardService: AdminDashboardService,
    private userService: UserService
  ) { }

  public getDashboardEmployee(employeeId: number): Observable<DashboardEmployee> {
    return this.adminDashboardService.getDashboardEmployeeById(employeeId)
  }

  public getProfilePictureByEmployeeId(employeeId: number): Observable<Blob> {
    return this.userService.getUserProfilePictureByEmployeeId(employeeId)
  }

  public mapCalendarStats(dashboardEmployee: DashboardEmployee, isAccepted: boolean): DashboardEmployeeCalendarStats {
    const statusString = isAccepted ? this.ACCEPTED_PREFIX : this.PENDING_PREFIX

    const calendarStats = dashboardEmployee.calendar_stats

    return new DashboardEmployeeCalendarStats(
      this.getCalendarStat(calendarStats, statusString, this.HOLIDAYS_SUFFIX),
      this.getCalendarStat(calendarStats, statusString, this.PERSONAL_MATTERS_SUFFIX),
      this.getCalendarStat(calendarStats, statusString, this.SICK_LEAVE_SUFFIX),
      this.getCalendarStat(calendarStats, statusString, this.PAID_LEAVE_SUFFIX),
      this.getCalendarStat(calendarStats, statusString, this.REMOTE_WORK_SUFFIX),
      calendarStats.total_prev_year_holidays,
    )
  }

  private getCalendarStat(calendarStats: UserCalendarStats, status: string, reason: string): number {
    return calendarStats[`total_${status}_${reason}`]
  }

  public fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return swal.fire(options)
  }
}
